import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "product-card-price-calculation" }
const _hoisted_2 = { class: "product-card-price-calculation__content" }
const _hoisted_3 = { class: "cost-container" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "cost-value"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "cost-item" }
const _hoisted_8 = { class: "cost-value" }
const _hoisted_9 = ["innerHTML"]

import {
  computed,
  PropType, ref,
} from 'vue';

import { Product } from '@/classes';
import { formatNumber } from '@/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceCalculation',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const product = ref<Product>(props.product);
const { price } = product.value;

const fixedBonus = product.value.getSummedBonus('fixed');
const fixedBonusValue = fixedBonus?.valueGrossFormatted;

const isBusiness = props.product.priceCustomerType === 'business';

const getWorkingPrice = () => (isBusiness
  ? price?.mapped.active.workingPrice ?? 0
  : price?.mapped.active.workingPriceGross ?? 0);

const getBasePrice = () => (isBusiness
  ? price?.mapped.active.basePrice ?? 0
  : price?.mapped.active.basePriceGross ?? 0);

const calcTotal = (workingPrice: number, usage: number) => formatNumber(+(workingPrice * usage).toFixed(2), 2);

const totals = computed(() => ({
  working: calcTotal(getWorkingPrice(), price?.params.usage ?? 0),
  workingHt: calcTotal(price?.mapped.active.workingPriceHtGross ?? 0, price?.params.usageHt ?? 0),
  workingNt: calcTotal(price?.mapped.active.workingPriceNtGross ?? 0, price?.params.usageNt ?? 0),
  base: formatNumber(getBasePrice() * 12, 2),
}));

const costItems = computed(() => {
  const items = [];

  if (product.value.priceIsDouble) {
    items.push(
      {
        label: 'Verbrauchsannahme HT',
        value: `${formatNumber(price?.params.usageHt, 0)} kWh`,
      },
      {
        label: '&times; Arbeitspreis HT',
        value: `${product.value.getPriceFormatted('workingPriceHt')} Cent/kWh`,
      },
      {
        label: '&equals; Arbeitspreis HT gesamt',
        value: `${totals.value.workingHt} €/Jahr`,
      },
      {
        label: '&plus; Verbrauchsannahme NT',
        value: `${formatNumber(price?.params.usageNt, 0)} kWh`,
      },
      {
        label: '&times; Arbeitspreis NT',
        value: `${product.value.getPriceFormatted('workingPriceNt')} Cent/kWh`,
      },
      {
        label: '&equals; Arbeitspreis NT gesamt',
        value: `${totals.value.workingNt} €/Jahr`,
      },
    );
  } else {
    items.push(
      {
        label: 'Verbrauchsannahme',
        value: `${product.value.priceUsageFormatted} kWh`,
      },
      {
        label: '&times; Arbeitspreis',
        value: `${product.value.getPriceFormatted('workingPrice')} Cent/kWh`,
      },
      {
        label: '&equals; Arbeitspreis gesamt',
        value: `${totals.value.working} €/Jahr`,
      },
    );
  }

  items.push(
    {
      label: '&plus; Grundpreis',
      value: `${totals.value.base} €/Jahr`,
    },
  );

  if (fixedBonus) {
    items.push(
      {
        label: '<b>= Jahreskosten</b>',
        value: `<b>${formatNumber(price?.mapped.active.yearlyGross, 2)} €/Jahr</b>`,
      },
      {
        label: '&minus; Bonus (Einmalig)',
        value: `${fixedBonusValue} €`,
      },
    );
  }

  items.push({
    label: fixedBonus
      ? '<b>= Jahreskosten abzgl. Bonus</b>'
      : '<b>= Jahreskosten</b>',
    value: `<b>${product.value.getPriceFormatted('yearly')} €/Jahr</b>`,
  });

  items.push({
    label: '&divide; 12 Monate',
  });

  return items;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "title" }, "Information zur Preisberechnung", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(costItems.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "cost-item"
          }, [
            _createElementVNode("div", {
              class: "cost-label",
              innerHTML: item.label
            }, null, 8, _hoisted_4),
            (item.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", {
                    innerHTML: item.value
                  }, null, 8, _hoisted_6)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _cache[1] || (_cache[1] = _createElementVNode("div", null, [
          _createElementVNode("hr", { class: "color-primary" })
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "cost-label" }, [
            _createElementVNode("b", null, "= Monatskosten")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("b", null, [
              _createElementVNode("span", {
                innerHTML: `${_unref(formatNumber)(product.value.getPriceValue('monthly'), 2)} €/Monat`
              }, null, 8, _hoisted_9)
            ])
          ])
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, " Sie zahlen 12 Abschläge, die sich an Ihrem realen Verbrauch orientieren. Der hier dargestellte, geschätzte Wert dient nur zu Ihrer Orientierung. ", -1))
    ])
  ]))
}
}

})